export default "__VITE_ASSET__f12ebc41__"